import { Button, Container, Flex, Link, Stack, Text } from "basis";
import { EventData } from "components/Analytics/types";
import { STATIC_RESOURCES } from "constants/contacts";
import { useEventTracking, usePageTracking } from "react-event-tracker";

const { tncPdfAu } = STATIC_RESOURCES;
const { tncPdfNz } = STATIC_RESOURCES;

interface Props {
  href: string;
  children: string | React.ReactNode;
  label: string;
  testId?: string;
  trackEvent: (data: { event: EventData }) => void;
  getQueryString: (data: { event: EventData }) => string;
}

const LinkWrapper = ({
  href,
  label,
  children,
  testId,
  trackEvent,
  getQueryString,
}: Props) => (
  <Link
    href={`${href}?${getQueryString({
      event: {
        category: "text-link",
        action: "internal-link",
        location: "Terms and Conditions",
        label,
      },
    })}`}
    testId={testId}
    newTab
    onClick={() => {
      trackEvent({
        event: {
          category: "text-link",
          action: "internal-link",
          location: "Terms and Conditions",
          label,
        },
      });
    }}
  >
    {children}
  </Link>
);

export const TermsOfUseComponent = ({
  setScreen,
}: {
  setScreen: (screenName: string) => void;
}) => {
  const { trackEvent, getQueryString } = useEventTracking();

  return (
    <Container bg="white" padding="10">
      <Stack gap="6">
        <Text as="h1" textStyle="heading4">
          Terms and Conditions
        </Text>
        <Text>
          By registering for a Latitude ID you agree to the following Terms and
          Conditions.
        </Text>
        <LinkWrapper
          href={tncPdfAu}
          label="Australian Latitude Service Centre Terms and Conditions"
          trackEvent={trackEvent}
          getQueryString={getQueryString}
        >
          Australian Latitude Service Centre Terms and Conditions
        </LinkWrapper>

        <LinkWrapper
          href={tncPdfNz}
          label="New Zealand Latitude Service Centre Terms and Conditions"
          trackEvent={trackEvent}
          getQueryString={getQueryString}
        >
          New Zealand Latitude Service Centre Terms and Conditions
        </LinkWrapper>
        <Flex>
          <Button
            width="120"
            onClick={() => {
              setScreen("RegistrationDetails");
              trackEvent({
                event: {
                  category: "application",
                  action: "registration-started",
                  location: "Terms and Conditions",
                  label: "I agree",
                },
              });
            }}
          >
            I agree
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setScreen("GetStarted");
              trackEvent({
                event: {
                  category: "application",
                  action: "registration-started",
                  location: "Terms and Conditions",
                  label: "Back",
                },
              });
            }}
            width="120"
            margin="0 0 0 8"
          >
            Back
          </Button>
        </Flex>
      </Stack>
    </Container>
  );
};

export const TermOfUse = (props: {
  setScreen: (screenName: string) => void;
}) => {
  usePageTracking({
    page: {
      pageType: "information-page",
      siteSection: "registration",
      siteSubSection: "",
      pageTitle: "terms",
    },
    user: {
      authenticationStatus: "not logged in",
    },
  });

  return <TermsOfUseComponent {...props} />;
};
